var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBuildingsSocialHousing(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-1970.000000, -772.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Buildings/Social-housing",
    transform: "translate(1970.000000, 772.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.575,22.3050533 C26.14,22.6750542 22.601,23.5860564 20.825,24.0420575 C20.826,24.0610575 20.827,24.1590577 20.829,24.3060581 C20.846,25.4090607 19.946,26.3150629 18.833,26.3150629 L10.041,26.3150629 C8.926,26.3150629 8.02,25.4180608 8.02,24.3150581 L18.833,24.3150581 C18.833,22.4840537 17.333,20.9980502 15.482,20.9980502 C15.482,20.9980502 14.029,21.0230502 13.468,21.0090502 C12.653,20.9900502 11.792,20.7680496 11.113,20.521049 C10.499,20.2970485 9.369,19.8640475 9.191,19.7990473 C7.803,19.3010461 4.532,18.3640439 0,20.9980502 L0,27.9980669 C0,27.9980669 8.981,31.5750755 12.082,31.9510764 C13.953,32.1800769 15.763,31.5710755 17.532,30.8340737 C19.063,30.1980722 32,24.1260577 32,24.1260577 C31.42,22.0990528 29.665,21.765052 27.575,22.3050533 M3.312,17.5280419 L3.312,9.96902383 L16.111,0 L28.687,9.96902383 L28.687,20.1120481 C28.175,20.1490482 27.64,20.2220483 27.074,20.3680487 C25.799,20.6980495 22.857,21.4540513 20.973,21.9400524 L20.346,22.1010528 C19.5,20.2720485 17.637,18.9980454 15.482,18.9980454 C15.445,18.9990454 14.596,19.0130454 13.958,19.0130454 C13.786,19.0130454 13.632,19.0120454 13.518,19.0090454 C13.035,18.9980454 12.409,18.8640451 11.797,18.6410446 C11.401,18.4970442 10.785,18.2630437 10.359,18.1020433 C10.123,18.0120431 9.942,17.9440429 9.878,17.9200428 C9.035,17.6180421 7.727,17.2220412 5.973,17.2220412 C5.094,17.2220412 4.205,17.3260414 3.312,17.5280419",
    id: 54
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildingsSocialHousing);
export default __webpack_public_path__ + "static/media/buildings-social-housing.dec94645.svg";
export { ForwardRef as ReactComponent };